import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 8\" id=\"arrow-down\"><path d=\"M4.202 7.285c.4.51 1.2.51 1.6 0l4-5.09c.494-.63.024-1.528-.8-1.528h-8c-.824 0-1.295.898-.8 1.527l4 5.091z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/arrow-down.svg
// module id = tewq
// module chunks = 39 44